import React from 'react';
import PropTypes from 'prop-types';

import { marketingPageUrl } from 'js/bulk_download/bulk_download_helper';
import OnsitePing from './onsite_ping';

const USABLE_FILTERS = [
  'topRelated',
  'sameAuthor',
  'citingThis',
  'citedByThis',
];

export default class BulkDownloadPing extends OnsitePing {
  static propTypes = {
    workId: PropTypes.string.isRequired,
    workTitle: PropTypes.string.isRequired,
    filterCounts: PropTypes.shape({
      topRelated: PropTypes.number,
      sameAuthor: PropTypes.number,
      citingThis: PropTypes.number,
      citedByThis: PropTypes.number,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    const filterCounts = props.filterCounts;

    this.totalCount = Object.keys(filterCounts)
      .filter((key) => USABLE_FILTERS.includes(key))
      .map((key) => filterCounts[key])
      .reduce((a, b) => a + b, 0);
  }

  getTitle() {
    return 'FIND THE PERFECT PAPER';
  }

  getBody() {
    let text;
    const { filterCounts } = this.props;

    if ('citingThis' in filterCounts && filterCounts['citingThis'] > 0) {
      text = filterCounts['citingThis'] + ' that cite it.';
    } else if (
      'citedByThis' in filterCounts &&
      filterCounts['citedByThis'] > 0
    ) {
      text = filterCounts['citedByThis'] + ' cited by it.';
    } else if ('topRelated' in filterCounts && filterCounts['topRelated'] > 0) {
      text = filterCounts['topRelated'] + ' top related papers.';
    } else if ('sameAuthor' in filterCounts && filterCounts['sameAuthor'] > 0) {
      text = filterCounts['sameAuthor'] + ' by the same author.';
    }

    return (
      <div className="text">
        With your download, get the{' '}
        <strong>{this.totalCount} best papers</strong> relevant to this one
        {text ? ', including ' : ''}
        <strong>{text ? text : '.'}</strong>
      </div>
    );
  }

  getUpgradeURL() {
    return marketingPageUrl(
      'bulk-download-onsite-ping', // trigger
      this.props.workId,
      this.props.workTitle,
      this.props.filterCounts,
    );
  }

  getButtonText() {
    return 'Upgrade for Bulk Download';
  }

  getIconClassName() {
    return 'fa fa-copy fa-lg icon';
  }
}
